import styled from '@emotion/styled'

export const TopLine = styled.div`
  align-items: flex-start;
  align-self: stretch;
  border-bottom: #cbcbcb 1px solid;
  display: flex;
  gap: 21px;
  padding-bottom: 1rem;
`
